<div class="referral-container">
    <button class="dialog-close" mat-icon-button mat-dialog-close matTooltip="Close" (click)="Close()">
        <mat-icon>close</mat-icon>
    </button>

    <div class="referral-header">
        <h5>Relocation Retention Promo Link</h5>
    </div>

    <div class="referral-body">
        <div class="info-box">
            <mat-icon>info</mat-icon>
            <span>
                <strong>
                    Use the link below to send to the customer and proceed with the  process
                </strong> 
            </span>
        </div>

        <label class="link-label">Promotion Link</label>

        <div class="link-box">
            <input type="text" [value]="relocationPromotionLink" readonly (click)="copyLink()" matTooltip="Click to Copy referral link" />
            <button (click)="copyLink()" matTooltip="Copy Promotion link">
                <mat-icon>content_copy</mat-icon>
            </button>
        </div>
    </div>
</div>